import { PostHogProvider } from '@posthog/react';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: false,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/venueintel\.xyz\/api/,
    /^https:\/\/.*\.supabase\.co/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
  enableLogs: true,
});

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
} as const;

function Root() {
  const app = (
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>
  );

  if (posthogKey && import.meta.env.PROD) {
    return (
      <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
        {app}
      </PostHogProvider>
    );
  }

  return app;
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
createRoot(rootElement).render(<Root />);
